export const sardoschau = {
  "Spezialist": {
    "vorhanden": {},
    "Titel": "",
    "Anrede": "Herr",
    "Vorname": "Nihad",
    "Nachname": "Sardoschau",
    "Profilbild": {
      "keineAngabe": {}
    },
    "Kontakt": {
      "vorhanden": {},
      "Telefon": {
        "vorhanden": {},
        "Rufnummer": "06 81 / 40 60"
      },
      "Fax": {
        "nichtVorhanden": {}
      },
      "EMail": {
        "nichtVorhanden": {}
      },
      "Homepage": {
        "nichtVorhanden": {}
      },
      "Mobil": {
        "nichtVorhanden": {}
      }
    }
  },
  "Einleitung_Spezialist_Text": {
    "keineAngabe": {}
  },
  "Arztqualifikationen": {
    "vorhanden": {},
    "Hauptqualifikation": {
      "vorhanden": {},
      "Bezeichnung": "Allgemeine Chirugie",
      "Uuid": "dsfdsfds"
    },
    "Weiterbildungen": {
      "keineAngabe": {}
    },
    "Zusatzqualifikationen": {
      "keineAngabe": {}
    },
    "Sonstige_Qualifikationen": {
      "keineAngabe": {}
    }
  },
  "Taetigkeits_Schwerpunkte": {
    "keineAngabe": {}
  },
  "Spezialist_Vita": {
    "keineAngabe": {}
  },
  "Auszeichnungen": {
    "keineAngabe": {}
  },
  "Weitere_Standorte": {
    "keineAngabe": {}
  },
  "Medienpraesenz": {
    "keineAngabe": {}
  },
  "Bilder": {
    "keineAngabe": {}
  },
  "Mitgliedschaften": {
    "keineAngabe": {}
  }
}
